export const SUBMIT_BUSINESS_REQUEST = `
  mutation SubmitBusinessRequest($input: CreateBusinessRequestInput!) {
    submitBusinessRequest(input: $input) {
      requestId
      status
      submittedAt
      submittedBy
    }
  }
`
